import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ChooseTime from "./ChooseTime";
import {
  getAvailableSlots,
  updateAvailableSlots,
} from "../../../ApiServices/ApiServices";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import { handleError, handleSuccess } from "../../../Utils";

const TimeSlots = ({ isVisible, setIsVisible, fetchProgressStatus }) => {
  const [selectedDayIndex, setSelectedDayIndex] = useState(0);
  const [isChooseTimeVisible, setIsChooseTimeVisible] = useState(false);
  const email = getEmail();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const fetchAvailableSlot = async () => {
        const slots = await getAvailableSlots(email);
        setWeekDaysAndTime(slots?.data);
      };
      fetchAvailableSlot();
    } catch (error) {
      return handleError(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }, [email]);

  const [weekDaysAndTime, setWeekDaysAndTime] = useState([
    {
      day: "MON",
      slots: 0,
      time: [],
    },
    {
      day: "TUE",
      slots: 0,
      time: [],
    },
    {
      day: "WED",
      slots: 0,
      time: [],
    },
    {
      day: "THU",
      slots: 0,
      time: [],
    },
    {
      day: "FRI",
      slots: 0,
      time: [],
    },
    {
      day: "SAT",
      slots: 0,
      time: [],
    },
    {
      day: "SUN",
      slots: 0,
      time: [],
    },
  ]);

  const update = async () => {
    try {
      const res = await updateAvailableSlots(email, weekDaysAndTime);
      handleSuccess(res?.message);
      setIsVisible(!isVisible);
      fetchProgressStatus();
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const handleRemoveTime = async (i) => {
    setWeekDaysAndTime((prev) =>
      prev.map((day, index) =>
        index === selectedDayIndex
          ? {
              ...day,
              time: day.time.filter((_, idx) => idx !== i),
              slots: Math.max(day.slots - 1, 0), // Ensure slots don't go below 0
            }
          : day
      )
    );
  };
  if (loading) return <p>Loading profile...</p>;

  return (
    <>
      {isVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl overflow-y-auto max-h-[80vh]">
            <div className="flex justify-end">
              <CloseIcon
                className="text-gray-500 cursor-pointer hover:text-red-500"
                onClick={() => setIsVisible(false)}
              />
            </div>
            <div className="text-lg font-semibold mb-4 text-left">
              Available Dates
            </div>
            <div
              className="flex gap-4 overflow-x-auto mb-4"
              style={{ scrollbarWidth: "none" }}
            >
              {weekDaysAndTime?.map((item, index) => {
                return (
                  <div
                    onClick={() => setSelectedDayIndex(index)}
                    key={index}
                    className={`flex flex-col items-center justify-center border rounded-lg py-2 min-w-[70px] cursor-pointer ${
                      selectedDayIndex === index
                        ? "bg-gray-300"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <div className="text-center text-sm w-full">
                      {item?.day}
                    </div>
                    {/* <div className="font-bold text-gray-800">{item?.date}</div> */}
                    <div className="text-green-500 font-bold text-sm">
                      {item?.slots}
                      {item?.slots === 1 || item?.slots === 0 ? (
                        <span> slot</span>
                      ) : (
                        <span> slots</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="border-t my-4"></div>
            <div className="flex justify-between items-center mb-2">
              <div className="font-semibold">Available Slots</div>
            </div>
            <div className="flex gap-4 overflow-x-auto mb-4">
              {weekDaysAndTime[selectedDayIndex]?.time?.map((time, index) => {
                return (
                  <div
                    className="flex flex-col items-center text-end"
                    key={index}
                  >
                    <span className={`w-full `}>
                      <RemoveCircleOutlineIcon
                        className="text-red-500 cursor-pointer"
                        style={{ fontSize: "16px" }}
                        onClick={() => handleRemoveTime(index)}
                      />
                    </span>
                    <div
                      className={`text-sm font-semibold border p-2 rounded-md min-w-[80px] `}
                      style={{ scrollbarWidth: "none" }}
                    >
                      {time?.value}
                    </div>
                  </div>
                );
              })}
              <div className="flex items-center justify-center cursor-pointer text-blue-500 mt-3">
                <AddCircleIcon onClick={setIsChooseTimeVisible} />
              </div>
            </div>
            <div className="flex justify-end">
              <button className="primary-btn" onClick={update}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
      {isChooseTimeVisible && (
        <ChooseTime
          isVisible={isChooseTimeVisible}
          setIsVisible={setIsChooseTimeVisible}
          weekDaysAndTime={weekDaysAndTime}
          setWeekDaysAndTime={setWeekDaysAndTime}
          index={selectedDayIndex}
        />
      )}
    </>
  );
};

export default TimeSlots;
